import { useEffect } from 'react';
import ConfirmDialog from '../components/ConfirmDialog';
import { useAuthStore, selectIsPro } from '../stores/authStore';
import { useToleranceStore } from '../stores/toleranceStore';
import { useTourStore } from './tourStore';
import { starteAngefordert } from './startTour';

// Startet die Tour, sobald sie angefordert wird (Banner oder Einstellungen).
// Ist schon eine eigene Kette offen, erst bestätigen lassen (aus dem
// Zustand abgeleitet, kein lokaler State).
export default function TourStarter() {
  const angefordert = useTourStore((s) => s.startAngefordert);
  const isPro = useAuthStore(selectIsPro);
  const hatKette = useToleranceStore((s) => s.elements.length > 0);
  const fragen = angefordert && hatKette;

  useEffect(() => {
    if (angefordert && !hatKette) starteAngefordert({ isPro });
  }, [angefordert, hatKette, isPro]);

  return (
    <ConfirmDialog
      open={fragen}
      title="Tour starten"
      message="Deine aktuelle Kette wird dabei ersetzt. Fortfahren?"
      confirmLabel="Fortfahren"
      cancelLabel="Abbrechen"
      onConfirm={() => starteAngefordert({ isPro })}
      onCancel={() => useTourStore.getState().startErledigt()}
    />
  );
}
